'use client;';
import { CallToActionButton } from '@/components/shared/CallToActionButton';

import Badge from '../shared/badge';
import { decode } from 'html-entities';
import { DotBlockEditor } from '../shared/decodeTextBlock';

function ReusableTitle({
    preheading,
    heading,
    subheading,
    callToAction,
    layout,
    easyToRead,
    switchBadgeToSubtitle
}) {
    const readableWidthClass = easyToRead ? 'max-w-[65ch] mb-1' : '';

    return (
        <div
            className="container mx-auto flex w-full flex-col items-center gap-6"
            data-component="heading"
            data-layout={layout}>
            {!switchBadgeToSubtitle && preheading && (
                <h2 className="text-base">
                    <Badge>{preheading}</Badge>
                </h2>
            )}
            {heading && (
                <DotBlockEditor
                    className="dark:text-white"
                    blocks={heading}
                    customRenderers={{
                        paragraph: (node) => {
                            const {
                                node: { content }
                            } = node;
                            if (!content || content.length === 0) {
                                return null;
                            }

                            const renderContent = (item) => {
                                if (item.marks && item.marks.some((mark) => mark.type === 'bold')) {
                                    return (
                                        <strong className="text-section-color">
                                            {decode(item.text)}
                                        </strong>
                                    );
                                }
                                return decode(item.text);
                            };

                            return (
                                <h3 className="text-center text-4xl">
                                    {content.map((item, index) => (
                                        <span key={index}>{renderContent(item)}</span>
                                    ))}
                                </h3>
                            );
                        }
                    }}
                />
            )}

            {Boolean(switchBadgeToSubtitle) && (
                <div className="text-2xl font-semibold text-blue-700">{preheading}</div>
            )}

            {subheading && (
                <DotBlockEditor
                    className={`dark:text-white ${readableWidthClass}`}
                    blocks={subheading}
                />
            )}

            {callToAction && callToAction.length > 0 && (
                <div className="mx-auto flex justify-center gap-6 md:gap-8">
                    {callToAction.map((cta, i) =>
                        cta.url ? (
                            <div key={cta.identifier + i}>
                                <CallToActionButton {...cta}>{cta.urlName}</CallToActionButton>
                            </div>
                        ) : null
                    )}
                </div>
            )}
        </div>
    );
}

export default ReusableTitle;
